export const createQueryParams = (queryMap: Record<string, string>) => {
    const queryString = Object.keys(queryMap)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(queryMap[key]))
        .join('&');
    return `?${queryString}`;
}